import { Box, Button, InputLabel, Select, Typography } from '@mui/material'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SelectChangeEvent } from '@mui/material/Select'

export const AddSupportHistoryForm: FC = (): JSX.Element => {
  const { t } = useTranslation()
  const [member, setMember] = React.useState('')
  const handleChangeMember = (event: SelectChangeEvent) => {
    setMember(event.target.value)
  }

  const [manager, setManager] = React.useState('')
  const handleChangeManager = (event: SelectChangeEvent) => {
    setManager(event.target.value)
  }

  return (
    <>
      <Box
        padding={'32px 16px'}
        sx={{
          borderTop: '1px solid rgba(0, 0, 0, 0.12)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }}
      >
        <Box display={'flex'} alignItems={'center'} sx={{ mb: 2 }}>
          <Typography
            sx={{ width: '84px', fontSize: '14px', lineHeight: '14px', color: '#000000', mr: 4 }}
          >
            {t('add_support_history.contents')}
          </Typography>
          <TextareaAutosize
            placeholder={
              '基本契約書のサインバックを受領。\n銀行入金用のP/Iを作成し、添付。入金は未確認。\nコンタクト注文の一部にキャンセル有り。'
            }
            style={{
              width: '100%',
              height: 120,
              border: '1px solid rgba(0, 0, 0, 0.23)',
              padding: 10,
              borderRadius: '4px',
              fontSize: 16,
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
              letterSpacing: 0.15,
            }}
          />
        </Box>
        <Box display={'flex'} alignItems={'center'} sx={{ mb: 2 }}>
          <Typography
            sx={{
              width: '84px',
              fontSize: '14px',
              lineHeight: '14px',
              color: '#000000',
              marginRight: '32px',
            }}
          >
            {t('add_support_history.member')}
          </Typography>
          <FormControl sx={{ width: '220px' }} size={'small'}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: 16,
                letterSpacing: 0.15,
              }}
            >
              {t('add_support_history.taro_tanaka')}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={member}
              label="Member"
              onChange={handleChangeMember}
              sx={{
                '& .MuiOutlinedInput-input': {
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.15,
                  lineHeight: '24px',
                },
              }}
            >
              <MenuItem
                value={10}
                sx={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.15,
                  lineHeight: '24px',
                }}
              >
                {t('add_support_history.taro_tanaka')}
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box display={'flex'} alignItems={'center'} sx={{ mb: 2 }}>
          <Typography
            sx={{
              width: '84px',
              fontSize: '14px',
              lineHeight: '14px',
              color: '#000000',
              marginRight: '32px',
            }}
          >
            {t('add_support_history.person_in_charge')}
          </Typography>
          <FormControl sx={{ width: '220px' }} size={'small'}>
            <InputLabel
              id="add-support-history-select-label"
              sx={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: 16,
                letterSpacing: 0.15,
              }}
            >
              {t('add_support_history.muraoka')}
            </InputLabel>
            <Select
              labelId="add-support-history-select-label"
              id="add-support-history-select"
              value={manager}
              label="Manager"
              onChange={handleChangeManager}
              sx={{
                '& .MuiOutlinedInput-input': {
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.15,
                  lineHeight: '24px',
                },
              }}
            >
              <MenuItem
                value={10}
                sx={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.15,
                  lineHeight: '24px',
                }}
              >
                {t('add_support_history.muraoka')}
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Typography
            sx={{
              width: '84px',
              fontSize: '14px',
              lineHeight: '14px',
              color: '#000000',
              marginRight: '32px',
            }}
          >
            {t('add_support_history.attachment')}
          </Typography>
          <Box>
            <Box
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'center'}
              sx={{
                width: 982,
                border: '3px dotted rgba(238, 238, 238, 1)',
                height: '134px',
                marginBottom: '16px',
              }}
            >
              <UploadFileOutlinedIcon sx={{ fontSize: 46.67, color: 'rgba(0, 0, 0, 0.54)' }} />
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <Typography
                  sx={{ marginRight: 1, fontSize: 16, lineHeight: '24px', fontWeight: 400 }}
                >
                  {t('add_support_history.drop_your_files_here_or')}
                </Typography>
                <label
                  htmlFor="upload-photo"
                  style={{
                    color: '#3F51B5',
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid rgba(63, 81, 181, 0.5)',
                    borderRadius: '4px',
                    padding: '4px 10px',
                  }}
                >
                  <input
                    style={{ display: 'none' }}
                    id="upload-photo"
                    name="upload-photo"
                    type="file"
                  />
                  <FileUploadIcon />
                  <Typography sx={{ fontSize: 13, lineHeight: '22px', fontWeight: '500' }}>
                    {t('add_support_history.upload')}
                  </Typography>
                </label>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: 982,
            marginLeft: '116px',
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: '4px',
            height: '120px',
            padding: '8px 12px',
          }}
        >
          <Typography sx={{ color: '#1F4266', fontSize: 16, lineHeight: '24px', fontWeight: 400 }}>
            hogehoge.png(1.5MB：2021/10/01 13:18：20)
          </Typography>
          <Typography sx={{ color: '#1F4266', fontSize: 16, lineHeight: '24px', fontWeight: 400 }}>
            hogehoge.png(1.5MB：2021/10/01 13:18：20)
          </Typography>
          <Typography sx={{ color: '#1F4266', fontSize: 16, lineHeight: '24px', fontWeight: 400 }}>
            hogehoge.png(1.5MB：2021/10/01 13:18：20)
          </Typography>
        </Box>
      </Box>
      <Box display={'flex'} justifyContent={'flex-end'} padding={2}>
        <Button
          variant="contained"
          startIcon={<SaveOutlinedIcon />}
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: 15,
            letterSpacing: 0.46,
          }}
        >
          {t('add_support_history.save')}
        </Button>
      </Box>
    </>
  )
}
